import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GalleryContainerComponent } from './components/gallery-container/gallery-container.component';
import { GalleryFiltersLoftComponent } from './components/gallery-filters-loft/gallery-filters-loft.component';
import { GalleryFiltersStudioComponent } from './components/gallery-filters-studio/gallery-filters-studio.component';
import { GalleryResultsComponent } from './components/gallery-results/gallery-results.component';
import { GalleryControlsComponent } from './components/gallery-controls/gallery-controls.component';
import { ButtonsModule } from '../shared/components/buttons/buttons.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxsModule } from '@ngxs/store';
import { GalleryState } from './state/gallery.state';
import { BookmarksModule } from '../bookmarks/bookmarks.module';
import { DirectivesModule } from '../shared/directives/directives.module';
import { ProgressIndictatorsModule } from '../shared/components/progress-indicators/progress-indicators.module';
import { ListModule } from '../shared/components/list/list.module';
import { GalleryCardComponent } from './components/gallery-cards/gallery-card/gallery-card.component';
import { GalleryCardsComponent } from './components/gallery-cards/gallery-cards/gallery-cards.component';
import { LazyLoadImageModule, intersectionObserverPreset } from 'ng-lazyload-image';
import { GalleryListComponent } from './components/gallery-list/gallery-list.component';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { SharedModule } from '../shared/shared.module';
import { MatCheckboxModule } from '@angular/material';
import { GalleryViewModeComponent } from './components/gallery-view-mode/gallery-view-mode.component';

@NgModule({
  declarations: [
    GalleryContainerComponent,
    GalleryFiltersLoftComponent,
    GalleryFiltersStudioComponent,
    GalleryResultsComponent,
    GalleryControlsComponent,
    GalleryListComponent,
    GalleryCardComponent,
    GalleryCardsComponent,
    GalleryViewModeComponent
  ],
  imports: [
    NgxsModule.forFeature([
      GalleryState
    ]),
    // Lazy Load Images
    LazyLoadImageModule.forRoot({
      preset: intersectionObserverPreset
    }),
    ButtonsModule,
    CommonModule,
    ReactiveFormsModule,
    BookmarksModule,
    DirectivesModule,
    ListModule,
    ProgressIndictatorsModule,
    VirtualScrollerModule,
    SharedModule,

    MatCheckboxModule
  ],
  exports: [
    GalleryContainerComponent,
    GalleryFiltersLoftComponent,
    GalleryFiltersStudioComponent,
    GalleryResultsComponent,
    GalleryControlsComponent,
    GalleryListComponent,
    GalleryCardComponent,
    GalleryCardsComponent,
    GalleryViewModeComponent
  ]
})
export class GalleryModule { }
